<app-timeline-transport-edit-order-modal></app-timeline-transport-edit-order-modal>

<jw-modal id="orderTransportInformationModal" class="jobInfoDrawer">
  <div class='jobInfoDrawerLayout'>
    <div class='jobInfoDrawerHeader'>
      <h1 class='header'>Order Information</h1>
      <button class='btn btn-secondary btn-sm' (click)='this.close()' title='Close'><i class="fas fa-times"></i></button>
    </div>

    <div class='jobInfoDrawerBody'>
      <div class='jobInfoRow'><span class='jobInfoLabel'>Order ID</span><span class='jobInfoValue'>{{ this.order.id }}</span></div>
      <div class='jobInfoRow'><span class='jobInfoLabel'>Account Name</span><span class='jobInfoValue'>{{ this.order.account.name }}</span></div>
      <div class='jobInfoRow'><span class='jobInfoLabel'>Site Name</span><span class='jobInfoValue'>{{ this.order.site.name }}</span></div>
      <div class='jobInfoRow'><span class='jobInfoLabel'>Time</span><span class='jobInfoValue'>{{ this.order.time }}</span></div>
      <div class='jobInfoRow'><span class='jobInfoLabel'>PO Number</span><span class='jobInfoValue'>{{ this.order.poNumber }}</span></div>
      <div class='jobInfoRow'><span class='jobInfoLabel'>Description</span><span class='jobInfoValue'>{{ this.order.description }}</span></div>
      <div class='jobInfoRow'><span class='jobInfoLabel'>Driver Notes</span><span class='jobInfoValue'>{{ this.order.driverNotes }}</span></div>
      <div class='jobInfoRow'><span class='jobInfoLabel'>Company Name</span><span class='jobInfoValue'>{{ this.order.companyName }}</span></div>
      <div class='jobInfoRow'><span class='jobInfoLabel'>Contact Name</span><span class='jobInfoValue'>{{ this.order.contactName }}</span></div>
      <div class='jobInfoRow'><span class='jobInfoLabel'>Contact Address Line 1</span><span class='jobInfoValue'>{{ this.order.contactAddressLine1 }}</span></div>
      <div class='jobInfoRow'><span class='jobInfoLabel'>Contact Address Line 2</span><span class='jobInfoValue'>{{ this.order.contactAddressLine2 }}</span></div>
      <div class='jobInfoRow'><span class='jobInfoLabel'>Contact Address Line 3</span><span class='jobInfoValue'>{{ this.order.contactAddressLine3 }}</span></div>
      <div class='jobInfoRow'><span class='jobInfoLabel'>Contact City</span><span class='jobInfoValue'>{{ this.order.contactCity }}</span></div>
      <div class='jobInfoRow'><span class='jobInfoLabel'>Contact Country</span><span class='jobInfoValue'>{{ this.order.contactCountry }}</span></div>
      <div class='jobInfoRow'><span class='jobInfoLabel'>Contact Postcode</span><span class='jobInfoValue'>{{ this.order.contactPostCode }}</span></div>
      <div class='jobInfoRow'><span class='jobInfoLabel'>Contact method</span><span class='jobInfoValue'>{{ this.order.contactEmail }}/{{ this.order.contactTelephone }}</span></div>

      <h2 class='jobInfoSectionHeading'>Rates</h2>
      <table class='table'>
        <thead>
          <th>Name</th>
          <th>Price</th>
          <th>Unit</th>
        </thead>
        <tbody>
          @for (line of this.order["orderLines"]; track line) {
            <tr>
              <td>{{ line.name }}</td>
              <td>{{ line.price }}</td>
              <td>{{ this.getUnitName(line.unitId) }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class='jobInfoDrawerFooter'>
      <a (click)='editOrder(this.order.id)' class='btn btn-warning'>Edit Order</a>
      <a href='/orders/copy/{{ this.order.id }}' target='_blank' class='btn btn-info'>Copy Order</a>
      @if (this.canDecline) {
        <a href='/orders/decline/{{ this.order.id }}' target='_blank' class='btn btn-danger'>Decline Order</a>
      }
    </div>
  </div>
</jw-modal>
